webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _esDynamicPolyfill = __webpack_require__(2);
	
	var _esDynamicPolyfill2 = _interopRequireDefault(_esDynamicPolyfill);
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _transition = __webpack_require__(5);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _scrollTop = __webpack_require__(6);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _scrollBlur = __webpack_require__(7);
	
	var _scrollBlur2 = _interopRequireDefault(_scrollBlur);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	console.log('Made by Pascal Klau\nwith \uD83D\uDC95 and \uD83C\uDF55\n\xA9 2016\nwww.artofmyself.com');
	
	// start Router on page load
	(0, _esDynamicPolyfill2.default)({
	    fills: 'fetch, Promise',
	    options: 'gated',
	    afterFill: function afterFill() {
	        main();
	    }
	});
	
	function main() {
	
	    (0, _router2.default)();
	    (0, _scrollBlur2.default)();
	
	    var app = (0, _jquery2.default)('#app'),
	        path = window.location.pathname;
	
	    // start Router on nav click
	    (0, _jquery2.default)('body').on('click', 'nav a', function (e) {
	        e.preventDefault();
	
	        var clicked = path.substr(0, path.lastIndexOf('/')) + (0, _jquery2.default)(this).attr('href'),
	            title = (0, _jquery2.default)(this).text();
	
	        // remove and add current
	        (0, _jquery2.default)('nav a').removeClass('is-current');
	        (0, _jquery2.default)(this).addClass('is-current');
	
	        // set url
	        console.log(clicked);
	        history.pushState(title, null, clicked);
	
	        // page transitions
	        (0, _transition2.default)();
	
	        (0, _scrollTop2.default)(400, function () {
	
	            (0, _jquery2.default)('#nav-main').addClass('fade-color');
	            (0, _jquery2.default)('#header, #content').removeClass('fade-in');
	            //setTimeout(() => {
	            (0, _jquery2.default)('.spinner').show();
	            //}, 500)
	        });
	
	        document.getElementById('content').onCSSTransitionEnd(function () {
	            (0, _router2.default)(clicked);
	        });
	    });
	}

/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (clicked) {
	
	    var app = (0, _jquery2.default)('#app'),
	        origin = window.location.pathname,
	        path = origin.substring(origin.lastIndexOf('/'));
	
	    getPage(path);
	
	    function getPage(clicked) {
	
	        var page = clicked ? clicked : path,
	            url = origin;
	
	        switch (page) {
	            case '/':
	                url = 'landing.html';
	                break;
	
	            case '/ortung':
	                url = 'ortung.html';
	                break;
	
	            case '/anschrift':
	                url = 'anschrift.html';
	                break;
	
	            case '/kaufverhalten':
	                url = 'kaufverhalten.html';
	                break;
	
	            case '/browser-verlauf':
	                url = 'browser-verlauf.html';
	                break;
	
	            default:
	                url = 'landing.html';
	                break;
	
	        }
	
	        // if( page === '/' ) {
	        //     url = '/landing.html';
	        // } else {
	        //     url = page + '/html';
	        // }
	
	
	        var title = page.replace('/', '').capitalize();
	
	        if (title !== '') {
	            title += ' | ';
	        }
	
	        document.title = title + 'Datensammlung';
	
	        loadData(page, url);
	    }
	
	    function loadData(page, url) {
	
	        (0, _jquery2.default)('body').removeClass().addClass(page.replace('/', ''));
	
	        fetch(url).then(function (res) {
	            return res.text();
	        }).then(function (html) {
	            app.html(html);
	
	            // add current link
	            if (page !== '/') {
	                (0, _jquery2.default)('nav a[href="' + page + '"]').addClass('is-current');
	                (0, _jquery2.default)('#nav-main').addClass('fade-in');
	            } else {
	                (0, _jquery2.default)('#nav-main').removeClass('fade-in');
	            }
	        }).then(function () {
	
	            var src = void 0;
	
	            page === '/' ? src = (0, _jquery2.default)('#content').css('background-image') : src = (0, _jquery2.default)('#header, #content').css('background-image');
	
	            //console.log(page);
	
	            (0, _utils.getLoadedBackground)(src, function () {
	                (0, _jquery2.default)('#nav-main').removeClass('fade-color');
	                (0, _jquery2.default)('#header, #content').addClass('fade-in');
	                (0, _jquery2.default)('#footer').css({ 'display': 'block' });
	                (0, _jquery2.default)('.spinner').hide();
	            });
	        });
	    }
	
	    window.addEventListener('popstate', function (e) {
	
	        var title = e.state,
	            url = e.state ? '/' + e.state.toLowerCase() : '';
	
	        console.log(url);
	
	        (0, _jquery2.default)('nav a').removeClass('is-current');
	
	        (0, _transition2.default)();
	
	        (0, _scrollTop2.default)(400, function () {
	
	            (0, _jquery2.default)('#header, #content').removeClass('fade-in');
	            //setTimeout(() => {
	            (0, _jquery2.default)('.spinner').show();
	            //}, 500)
	        });
	
	        document.getElementById('content').onCSSTransitionEnd(function () {
	
	            if (title === null) {
	                loadData('/', window.location.pathname + '/landing.html');
	                document.title = 'Datensammlung';
	            } else getPage(url);
	        });
	    }); // end pop
	};
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _utils = __webpack_require__(4);
	
	var _transition = __webpack_require__(5);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _scrollTop = __webpack_require__(6);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getLoadedBackground = getLoadedBackground;
	
	
	// Capitalize Strings - src.capitalize()
	String.prototype.capitalize = function () {
	    return this.replace(/\b\w/g, function (l) {
	        return l.toUpperCase();
	    });
	};
	
	// Wait for CSS Background Images for be loaded
	function getLoadedBackground(src, cb) {
	
	    var url = src.match(/\((.*?)\)/)[1].replace(/('|")/g, ''),
	        img = new Image();
	
	    img.onload = function () {
	        return cb();
	    };
	
	    img.src = url;
	    if (img.complete) img.onload();
	}

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	
	    var s = document.body || document.documentElement,
	        s = s.style,
	        /*prefixAnimation = '',*/prefixTransition = '';
	
	    if (s.WebkitTransition == '') prefixTransition = '-webkit-';
	    if (s.MozTransition == '') prefixTransition = '-moz-';
	    if (s.OTransition == '') prefixTransition = '-o-';
	
	    Object.prototype.onCSSTransitionEnd = function (callback) {
	
	        var runOnce = function runOnce(e) {
	            callback();e.target.removeEventListener(e.type, runOnce);
	        };
	        this.addEventListener('webkitTransitionEnd', runOnce);
	        this.addEventListener('mozTransitionEnd', runOnce);
	        this.addEventListener('oTransitionEnd', runOnce);
	        this.addEventListener('transitionend', runOnce);
	        this.addEventListener('transitionend', runOnce);
	        if (prefixTransition == '' && !('transition' in s)) /*|| getComputedStyle( this )[ prefixAnimation + 'transition-duration' ] == '0s'*/callback();
	        return this;
	    };
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = scrollToTop;
	function scrollToTop(scrollDuration, cb) {
	
	    var scrollHeight = window.scrollY,
	        scrollStep = Math.PI / (scrollDuration / 15),
	        cosParameter = scrollHeight / 2;
	    var scrollCount = 0,
	        scrollMargin,
	        scrollInterval = setInterval(function () {
	        if (window.scrollY != 0) {
	            scrollCount = scrollCount + 1;
	            scrollMargin = cosParameter - cosParameter * Math.cos(scrollCount * scrollStep);
	            window.scrollTo(0, scrollHeight - scrollMargin);
	        } else {
	            clearInterval(scrollInterval);
	            cb();
	        }
	    }, 15);
	}

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	
	    var wWidth = (0, _jquery2.default)(window).width();
	
	    (0, _jquery2.default)(window).on('scroll', function () {
	
	        var wScroll = (0, _jquery2.default)(window).scrollTop();
	        var headerHeight = (0, _jquery2.default)('#header').innerHeight();
	
	        var blur = (0, _jquery2.default)('.scrollBlur');
	
	        if (wScroll <= headerHeight) {
	
	            //let blur = Math.round(wScroll * .05);
	            var opacity = wScroll / (wWidth / 7);
	
	            //console.log(wWidth, opacity);
	
	            //blur.css({'filter': 'blur(' + blur + 'px)'});
	            blur.css({ 'opacity': opacity });
	        }
	    });
	};
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }
]);


// WEBPACK FOOTER //
// main.js